{
  "dashboard.activity.empty": "此时间范围内没有活动记录。",
  "dashboard.activity.error": "无法加载最近活动，请重试。",
  "dashboard.activity.failed": "失败",
  "dashboard.activity.failed_jobs": "失败任务",
  "dashboard.activity.operations": "最近操作",
  "dashboard.activity.security_events": "安全事件",
  "dashboard.activity.succeeded": "成功",
  "dashboard.activity.title": "最近活动",
  "dashboard.activity.unknown_error": "未知错误码",
  "dashboard.intro": "集中查看你的工作区与可用管理功能。",
  "dashboard.metrics.jobs.failed": "失败任务",
  "dashboard.metrics.messages.published": "已发布通知",
  "dashboard.metrics.security.open": "未解决安全事件",
  "dashboard.metrics.sessions.active": "活动会话",
  "dashboard.metrics.users.new": "新增用户",
  "dashboard.metrics.users.total": "用户总数",
  "dashboard.quick_access": "快速访问",
  "dashboard.range.30d": "30 天",
  "dashboard.range.7d": "7 天",
  "dashboard.range.90d": "90 天",
  "dashboard.range.label": "时间范围",
  "dashboard.severity.critical": "严重",
  "dashboard.severity.high": "高",
  "dashboard.severity.info": "信息",
  "dashboard.severity.low": "低",
  "dashboard.severity.medium": "中",
  "dashboard.summary.empty": "当前账号没有可查看的指标。",
  "dashboard.summary.error": "无法加载 Dashboard 指标，请重试。",
  "dashboard.summary.title": "关键指标",
  "dashboard.trends.chart_label": "Dashboard 每日趋势折线图",
  "dashboard.trends.day": "日期",
  "dashboard.trends.empty": "当前账号没有可查看的趋势数据。",
  "dashboard.trends.error": "无法加载趋势数据，请重试。",
  "dashboard.trends.series.jobs.failed": "失败任务",
  "dashboard.trends.series.logins.failure": "失败登录",
  "dashboard.trends.series.logins.success": "成功登录",
  "dashboard.trends.series.security.events": "安全事件",
  "dashboard.trends.series.users.new": "新增用户",
  "dashboard.trends.table_toggle": "查看趋势数据表",
  "dashboard.trends.title": "趋势",
  "menu.dashboard": "Dashboard",
  "menu.system": "系统",
  "menu.system.access": "权限设置",
  "menu.system.access.menus": "菜单",
  "menu.system.access.permissions": "权限目录",
  "menu.system.access.roles": "角色",
  "menu.system.content": "内容管理",
  "menu.system.content.articles": "文章管理",
  "menu.system.content.categories": "文章分类",
  "menu.system.integrations": "任务集成",
  "menu.system.integrations.api-clients": "API 客户端",
  "menu.system.integrations.schedules": "定时任务",
  "menu.system.integrations.webhooks": "Webhook",
  "menu.system.mobile": "移动端管理",
  "menu.system.mobile.releases": "发布策略",
  "menu.system.monitoring": "运行监控",
  "menu.system.monitoring.health": "服务状态",
  "menu.system.monitoring.sessions": "在线会话",
  "menu.system.notifications": "通知中心",
  "menu.system.notifications.deliveries": "投递记录",
  "menu.system.notifications.push_channels": "推送渠道",
  "menu.system.notifications.messages": "站内消息",
  "menu.system.notifications.notices": "公告管理",
  "menu.system.notifications.templates": "通知模板",
  "menu.system.security": "审计安全",
  "menu.system.security.block-rules": "访问控制",
  "menu.system.security.events": "安全事件",
  "menu.system.security.login-logs": "登录日志",
  "menu.system.security.operation-logs": "操作日志",
  "menu.system.settings": "系统设置",
  "menu.system.settings.configs": "系统配置",
  "menu.system.settings.dictionaries": "字典管理",
  "menu.system.settings.modules": "模块信息",
  "menu.system.settings.regions": "地区管理",
  "menu.system.storage": "文件存储",
  "menu.system.storage.files": "文件管理",
  "menu.system.users": "用户管理",
  "menu.system.users.accounts": "用户",
  "menu.system.users.departments": "部门",
  "menu.system.users.positions": "岗位",
  "menu.system.users.tenants": "租户",
  "routes.auth.forgot-password.title": "找回密码",
  "routes.auth.login.title": "登录",
  "routes.auth.oauth-callback.title": "第三方登录",
  "routes.auth.register.title": "注册",
  "routes.auth.reset-password.title": "重置密码",
  "routes.dashboard.title": "Dashboard",
  "routes.errors.forbidden.title": "无权访问",
  "routes.errors.not-found.title": "页面不存在",
  "routes.errors.offline.dashboard": "返回仪表盘",
  "routes.errors.offline.description": "后台管理当前无法连接网络。请检查网络后重试本页面；未完成的写操作不会自动重放。",
  "routes.errors.offline.retry": "重试连接",
  "routes.errors.offline.title": "网络不可用",
  "routes.errors.server-error.title": "服务异常",
  "routes.profile.basic.title": "基本设置",
  "routes.profile.connections.title": "第三方绑定",
  "routes.profile.security.title": "安全设置",
  "routes.system.access.menus.title": "菜单",
  "routes.system.access.permissions.title": "权限目录",
  "routes.system.access.role-detail.title": "角色详情",
  "routes.system.access.roles.title": "角色",
  "routes.system.content.articles.title": "文章管理",
  "routes.system.content.categories.title": "文章分类",
  "routes.system.integrations.api-client-detail.title": "API 客户端详情",
  "routes.system.integrations.api-clients.title": "API 客户端",
  "routes.system.integrations.schedule-runs.title": "执行记录",
  "routes.system.integrations.schedules.title": "定时任务",
  "routes.system.integrations.webhook-deliveries.title": "Webhook 投递记录",
  "routes.system.integrations.webhooks.title": "Webhook",
  "routes.system.mobile.releases.title": "移动端发布策略",
  "routes.system.monitoring.health.title": "服务状态",
  "routes.system.monitoring.sessions.title": "在线会话",
  "routes.system.notifications.deliveries.title": "投递记录",
  "routes.system.notifications.push_channels.title": "推送渠道",
  "routes.system.notifications.message-detail.title": "消息详情",
  "routes.system.notifications.messages.title": "站内消息",
  "routes.system.notifications.notice-detail.title": "公告详情",
  "routes.system.notifications.notices.title": "公告管理",
  "routes.system.notifications.templates.title": "通知模板",
  "routes.system.security.block-rules.title": "访问控制",
  "routes.system.security.event-detail.title": "安全事件详情",
  "routes.system.security.events.title": "安全事件",
  "routes.system.security.login-logs.title": "登录日志",
  "routes.system.security.operation-logs.title": "操作日志",
  "routes.system.settings.configs.title": "系统配置",
  "routes.system.settings.dictionaries.title": "字典管理",
  "routes.system.settings.modules.title": "模块信息",
  "routes.system.settings.regions.title": "地区管理",
  "routes.system.storage.file-detail.title": "文件详情",
  "routes.system.storage.files.title": "文件管理",
  "routes.system.users.account-detail.title": "用户详情",
  "routes.system.users.accounts.title": "用户",
  "routes.system.users.departments.title": "部门",
  "routes.system.users.positions.title": "岗位",
  "routes.system.users.tenant-detail.title": "租户详情",
  "routes.system.users.tenants.title": "租户",
  "shell.account_information": "当前用户信息与账户菜单",
  "shell.account_no_roles": "未分配角色",
  "shell.account_roles": "所属角色",
  "shell.collapse_navigation": "收起导航",
  "shell.current_tenant": "当前工作区",
  "shell.enter_fullscreen": "进入全屏",
  "shell.exit_fullscreen": "退出全屏",
  "shell.expand_navigation": "展开导航",
  "shell.fullscreen_error": "无法切换全屏模式",
  "shell.hide_navigation": "完全隐藏导航",
  "shell.navigation": "主导航",
  "shell.open_account_menu": "打开用户菜单",
  "shell.open_navigation": "打开导航",
  "shell.personal_center": "个人中心",
  "shell.skip_to_content": "跳到主要内容",
  "shell.switch_tenant": "切换工作区",
  "shell.tenant_switch_error": "工作区切换失败，请重试",
  "shell.tenant_switch_success": "工作区已切换",
  "menu.app": "App管理",
  "menu.app.applications": "应用管理",
  "menu.app.upgrade_center": "App升级中心",
  "menu.app.users": "用户管理",
  "menu.app.content": "内容管理",
  "menu.app.content.articles": "文章管理",
  "menu.app.content.pages": "单页内容",
  "routes.app.applications.title": "应用管理",
  "routes.app.upgrade_center.title": "App升级中心",
  "routes.app.users.title": "App 用户管理",
  "routes.app.content.articles.title": "App 文章管理",
  "routes.app.content.pages.title": "App 单页内容",
  "menu.system.settings.share_configs": "分享配置",
  "routes.system.settings.share_configs.title": "分享配置",
  "menu.system.notifications.operations": "消息运营",
  "routes.system.notifications.operations.title": "消息运营",
  "menu.app.feedbacks": "问题反馈",
  "routes.app.feedbacks.title": "问题反馈",
  "menu.system.settings.login_providers": "第三方登录配置",
  "routes.system.settings.login_providers.title": "第三方登录配置",
  "menu.system.ai": "AI 中心",
  "menu.system.ai.providers": "供应商",
  "routes.system.ai.providers.title": "供应商",
  "menu.system.ai.models": "模型与路由",
  "routes.system.ai.models.title": "模型与路由",
  "menu.system.ai.access": "应用与授权",
  "routes.system.ai.access.title": "应用与授权",
  "menu.system.ai.playground": "模型调试台",
  "routes.system.ai.playground.title": "模型调试台",
  "menu.system.ai.usage": "用量与记录",
  "routes.system.ai.usage.title": "用量与记录",
  "menu.app.support": "AI 客服",
  "menu.app.support.inbox": "接待工作台",
  "routes.app.support.inbox.title": "接待工作台",
  "menu.app.support.sites": "网站接入",
  "routes.app.support.sites.title": "网站接入",
  "menu.app.support.characters": "客服角色",
  "routes.app.support.characters.title": "客服角色",
  "menu.app.support.products": "商品资料",
  "routes.app.support.products.title": "商品资料",
  "menu.app.support.faq": "知识与 FAQ",
  "routes.app.support.faq.title": "知识与 FAQ",
  "menu.app.support.settings": "客服设置",
  "routes.app.support.settings.title": "客服设置",
  "dashboard.scope_hint": "当前租户 · 日期按 UTC 统计；通知按创建日期统计当前状态，已发送不代表用户已收到。",
  "dashboard.metrics.applications.active": "启用应用数（当前）",
  "dashboard.metrics.members.total": "会员总数（跨应用去重）",
  "dashboard.metrics.members.new": "期间新增会员",
  "dashboard.trends.series.members.new": "新增会员",
  "dashboard.metrics.articles.published": "已发布资讯（当前）",
  "dashboard.trends.series.articles.published": "发布资讯",
  "dashboard.metrics.articles.draft": "资讯草稿（当前）",
  "dashboard.metrics.deliveries.sent": "已发送通知（期间创建）",
  "dashboard.trends.series.deliveries.sent": "已发送",
  "dashboard.metrics.deliveries.failed": "失败通知（期间创建）",
  "dashboard.trends.series.deliveries.failed": "失败",
  "dashboard.metrics.deliveries.pending": "待处理通知（期间创建）",
  "dashboard.trends.series.deliveries.pending": "待处理",
  "dashboard.groups.business": "应用与会员",
  "dashboard.groups.content": "资讯发布",
  "dashboard.groups.delivery": "通知投递",
  "dashboard.groups.system": "系统概览",
  "dashboard.groups.growth": "用户与会员增长",
  "dashboard.groups.logins": "登录趋势",
  "dashboard.groups.risk": "任务与安全",
  "menu.app.commerce": "官方商店",
  "routes.app.commerce.title": "官方商店"
}
